module.exports = __webpack_public_path__ + "static/media/avatar5.6e1b6acd.jpg";